import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(
    private titleService: Title,
    public _router: Router
    ) {
    this.titleService.setTitle('Page Not Found | VeEX Inc. | The Verification EXperts');
  }

  notfoundsearch: string;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {
  }

  submitSearch(): void {
    this._router.navigate(['/search'], { queryParams: { q: this.notfoundsearch }, queryParamsHandling: 'merge' });
    setTimeout(() => {
      this.notfoundsearch = '';
    }, 200);
  }

}
